import { Route, PreloadingStrategy } from '@angular/router';
import { Observable, of } from 'rxjs';

export class CustomPreloading implements PreloadingStrategy {
    // tslint:disable-next-line:ban-types
    preload(route: Route, preload: Function): Observable<any> {
        return (route.data && route.data.preload) ? preload() : of(null);
    }
}
